export const dispatchPopStateEvent = () => {
  const popStateEvent = new PopStateEvent('popstate')

  window.dispatchEvent(popStateEvent)
}
